import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import * as validators from '../../util/validators';
import getCountryCodes from '../../translations/countryCodes';
import getAboutVegshelfCategories from '../../translations/aboutVegshelfCategories';
import getAnnualSales from '../../translations/annualSales';
import getNumberOfStores, { getLeadTime } from '../../translations/numberOfStores';
import getPrimaryCategories from '../../translations/primaryCategories';
import { Form, PrimaryButton, FieldTextInput, FieldCheckbox, FieldSelect, FieldPhoneNumberInput } from '../../components';
import { localePart, storedLocale } from '../../components/Wrapper/ClassWrapper';

import css from './SupplierRegistrationForm.module.css';

const KEY_CODE_ENTER = 13;

export class SupplierRegistrationFormComponent extends Component {

  constructor(props) {
    super(props);
    this.state = { categoryCustomEnable: false, aboutTypeEnable: false, countryEnable: false };
    this.onChangeAbout = this.onChangeAbout.bind(this);
    this.onChangeCategory = this.onChangeCategory.bind(this);
    this.onChangeCountry = this.onChangeCountry.bind(this);
  }
  onChangeCountry(event) {
    this.setState({ ... this.state, countryEnable: event == 'Other' });
  }
  onChangeCategory(event) {
    this.setState({ ... this.state, categoryCustomEnable: event == 'Other' });
  }
  onChangeAbout(event) {
    this.setState({ ... this.state, aboutTypeEnable: event == 'Other' });

  }
  render() {
    return (
      <FinalForm
        {...this.props}
        render={formRenderProps => {
          const {
            rootClassName,
            className,
            formId,
            handleSubmit,
            inProgress,
            invalid,
            intl,
            idp,
            values,
            submitFailed,
            touched,
            email,
          } = formRenderProps;

          const classes = classNames(rootClassName || css.root, className);
          const submitInProgress = inProgress;
          const submitDisabled = invalid || submitInProgress;
          const emailValid = validators.emailFormatValid('*');
          const countries = [...getCountryCodes(), { code: '', callCode: '', name: 'Other' }];
          const vatCodes = [...countries];
          const aboutVegshelfCategories = getAboutVegshelfCategories();
          const annualSales = getAnnualSales();
          const numberOfStores = getNumberOfStores();
          const primaryCategories = getPrimaryCategories();
          const leadTimes = getLeadTime();
          const hasError = (field) => {
            return (values[field] === undefined || (values[field] instanceof Array && !values[field].length)) && (submitFailed || touched[field]);
          };
          const pleaseSelectText = intl.formatMessage({ id: "BuyerRegistrationForm.optionPleaseSelect" });
          //const locale = sessionStorage.getItem('locale') || localePart();
          const locale = storedLocale() || localePart();

          return (
            <Form className={classes} onSubmit={handleSubmit}>
              <div className={css.formFields}>
                <div className={css.formRow}>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.brandName` : 'brandName'}>
                      <FormattedMessage id="UserFields.brandName" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('brandName') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldTextInput
                        type="text"
                        id={formId ? `${formId}.brandName` : 'brandName'}
                        name="brandName"
                        validate={validators.required('*')}
                      />
                    </div>
                  </div>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.instagram` : 'instagram'}>
                      <FormattedMessage id="UserFields.instagram" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('instagram') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <div className={css.placeholderContainer}>
                        <FieldTextInput
                          type="text"
                          id={formId ? `${formId}.instagram` : 'instagram'}
                          name="instagram"
                          validate={validators.required('*')}
                          className={css.instagramInput}
                        />
                        <div className={css.instagramPlaceholder}>@</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={css.formRow}>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.firstName` : 'firstName'}>
                      <FormattedMessage id="UserFields.name" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('firstName') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldTextInput
                        type="text"
                        id={formId ? `${formId}.firstName` : 'firstName'}
                        name="firstName"
                        validate={validators.required('*')}
                      />
                    </div>
                  </div>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.lastName` : 'lastName'}>
                      <FormattedMessage id="UserFields.surname" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('lastName') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldTextInput
                        type="text"
                        id={formId ? `${formId}.lastName` : 'lastName'}
                        name="lastName"
                        validate={validators.required('*')}
                      />
                    </div>
                  </div>
                </div>
                <div className={css.formRow}>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.position` : 'position'}>
                      <FormattedMessage id="UserFields.position" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('position') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldTextInput
                        type="text"
                        id={formId ? `${formId}.position` : 'position'}
                        name="position"
                        validate={validators.required('*')}
                      />
                    </div>
                  </div>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.phoneNumber` : 'phoneNumber'}>
                      <FormattedMessage id="UserFields.phoneNumber" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('phoneNumber') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldPhoneInput}>
                      <FieldSelect
                        id={formId ? `${formId}.phoneCode` : 'phoneCode'}
                        name="phoneCode" viewError={hasError('phoneNumber')}
                        className={css.phoneCode} onChange={(e) => this.setState({ ...this.state, callCode: e })}
                      >
                        {countries.map(c => {
                          return (
                            <option key={`phoneCodeSelect${c.callCode}`} value={c.callCode}>
                              {c.name}
                            </option>
                          );
                        })}
                      </FieldSelect>
                      <div className={css.fieldWithCountry}>
                        <FieldPhoneNumberInput
                          id={formId ? `${formId}.phoneNumber` : 'phoneNumber'}
                          name="phoneNumber"
                          className={classNames(css.phoneCodeInput, { [css.emptyPhoneCode]: !this.state.callCode })}
                          validate={validators.required('*')}
                        />
                        <div className={css.inputCodePlaceholder}>{this?.state?.callCode}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={css.formRow}>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.businessEMail` : 'businessEMail'}>
                      <FormattedMessage id="UserFields.email" />
                      <span className={css.requiredMarker}>*</span>
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldTextInput
                        type="email"
                        id={formId ? `${formId}.businessEMail` : 'businessEMail'}
                        name="businessEMail"
                        defaultValue={email}
                        readOnly={true}
                      />
                    </div>
                  </div>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.companyName` : 'companyName'}>
                      <FormattedMessage id="UserFields.companyName" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('companyName') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldTextInput
                        type="text"
                        id={formId ? `${formId}.companyName` : 'companyName'}
                        name="companyName"
                        validate={validators.required('*')}
                      />
                    </div>
                  </div>
                </div>
                <div className={css.formRow}>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.companyRegistrationNumber` : 'companyRegistrationNumber'}>
                      <FormattedMessage id="UserFields.companyRegNr" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('companyRegistrationNumber') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldTextInput
                        type="text"
                        id={formId ? `${formId}.companyRegistrationNumber` : 'companyRegistrationNumber'}
                        name="companyRegistrationNumber"
                        validate={validators.required('*')}
                      />
                    </div>
                  </div>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.companyVATnumber` : 'companyVATnumber'}>
                      <FormattedMessage id="UserFields.companyVatNr" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('companyVATnumber') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldPhoneInput}>
                      <FieldSelect
                        id={formId ? `${formId}.companyVATcode` : 'companyVATcode'}
                        name="companyVATcode" 
                        viewError={hasError('companyVATnumber')}
                        className={css.vatCode} 
                        onChange={(e) => this.setState({ ...this.state, vatCode: e })}
                      >
                        {vatCodes.map(c => {
                          return (
                            <option key={`companyVATcodeSelect${c.code}`} value={c.code}>
                              {c.name}
                            </option>
                          );
                        })}
                      </FieldSelect>
                      <div className={css.fieldWithCountry}>
                        <FieldTextInput
                          type="text"
                          className={classNames(css.phoneCodeInput, { [css.emptyPhoneCode]: !this.state.vatCode })}
                          id={formId ? `${formId}.companyVATnumber` : 'companyVATnumber'}
                          name="companyVATnumber"
                          validate={validators.required('*')}
                        />
                        <div className={css.inputCodePlaceholder}>{this?.state?.vatCode}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={css.formRow}>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.streetAndNumber` : 'streetAndNumber'}>
                      <FormattedMessage id="UserFields.streetAndNumber" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('streetAndNumber') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldTextInput
                        type="text"
                        id={formId ? `${formId}.streetAndNumber` : 'streetAndNumber'}
                        name="streetAndNumber"
                        validate={validators.required('*')}
                      />
                    </div>
                  </div>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.city` : 'city'}>
                      <FormattedMessage id="UserFields.city" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('city') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldTextInput
                        type="text"
                        id={formId ? `${formId}.city` : 'city'}
                        name="city"
                        validate={validators.required('*')}
                      />
                    </div>
                  </div>
                </div>
                <div className={css.formRow}>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.postcode` : 'postcode'}>
                      <FormattedMessage id="UserFields.zipCode" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('postcode') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldTextInput
                        type="text"
                        id={formId ? `${formId}.postcode` : 'postcode'}
                        name="postcode"
                        validate={validators.required('*')}
                      />
                    </div>
                  </div>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.country` : 'country'}>
                      <FormattedMessage id="UserFields.country" />
                      <span className={css.requiredMarker}>*</span>
                      {(hasError('country') || (this.state.countryEnable && hasError('countryCustom'))) && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldSelect
                        id={formId ? `${formId}.country` : 'country'}
                        name="country"
                        className={css.country}
                        onChange={this.onChangeCountry}
                        viewError={(hasError('country') || (this.state.countryEnable && hasError('countryCustom')))}
                        validate={validators.required('*')}
                      >
                        <option value="" disabled={true}>{pleaseSelectText}</option>
                        {countries.map(c => {
                          return (
                            <option key={`countrySelect${c.name}`} value={c.name}>
                              {c.name}
                            </option>
                          );
                        })}
                      </FieldSelect>
                      {this.state.countryEnable ? (
                        <FieldTextInput
                          type="text"
                          id={formId ? `${formId}.countryCustom` : 'countryCustom'}
                          name="countryCustom"
                          validate={validators.required('*')}
                        />) : null}
                    </div>
                  </div>
                </div>
                <div className={css.formRow}>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.establishedIn` : 'establishedIn'}>
                      <FormattedMessage id="UserFields.yearEstablished" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('establishedIn') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldTextInput
                        type="text"
                        id={formId ? `${formId}.establishedIn` : 'establishedIn'}
                        name="establishedIn"
                        validate={validators.required('*')}
                      />
                    </div>
                  </div>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.annualSales` : 'annualSales'}>
                      <FormattedMessage id="UserFields.annualSales" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('annualSales') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldSelect
                        id={formId ? `${formId}.annualSales` : 'annualSales'}
                        name="annualSales"
                        className={css.annualSales}
                        validate={validators.required('*')}
                      >
                        <option value="" disabled={true}>{pleaseSelectText}</option>
                        {annualSales.map(c => {
                          return (
                            <option key={`annualSalesSelect${c.name}`} value={c.name}>
                              {c.name}
                            </option>
                          );
                        })}
                      </FieldSelect>
                    </div>
                  </div>
                </div>
                <div className={css.formRow}>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.primaryCategory` : 'primaryCategory'}>
                      <FormattedMessage id="SupplierRegistrationForm.labelPrimaryCategory" />
                      <span className={css.requiredMarker}>*</span>
                      {(hasError('primaryCategory') || (this.state.categoryCustomEnable && hasError('primaryCategoryCustom'))) && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldSelect
                        id={formId ? `${formId}.primaryCategory` : 'primaryCategory'}
                        name="primaryCategory"
                        className={css.productCategory}
                        validate={validators.required('*')}
                        viewError={(hasError('primaryCategory') || (this.state.categoryCustomEnable && hasError('primaryCategoryCustom')))}
                        onChange={this.onChangeCategory}
                      >
                        <option value="" disabled={true}>{pleaseSelectText}</option>
                        {primaryCategories.map(c => {
                          return (
                            <option key={`primaryCategory${c.name}`} value={c.name}>
                              {c.name}
                            </option>
                          );
                        })}
                      </FieldSelect>
                      {this.state.categoryCustomEnable ? (
                        <FieldTextInput
                          type="text"
                          id={formId ? `${formId}.primaryCategoryCustom` : 'primaryCategoryCustom'}
                          name="primaryCategoryCustom"
                          validate={validators.required('*')}
                        />) : null}
                    </div>
                  </div>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.numberOfProducts` : 'numberOfProducts'}>
                      <FormattedMessage id="SupplierRegistrationForm.labelProductsInAssortment" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('numberOfProducts') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldTextInput
                        type="number"
                        id={formId ? `${formId}.numberOfProducts` : 'numberOfProducts'}
                        name="numberOfProducts"
                        min='1'
                        validate={validators.required('*')}
                      />
                    </div>
                  </div>
                </div>
                <div className={css.formRow}>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.numberOfStoresYouWorkWith` : 'numberOfStoresYouWorkWith'}>
                      <FormattedMessage id="UserFields.numberOfStockists" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('numberOfStoresYouWorkWith') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldSelect
                        id={formId ? `${formId}.numberOfStoresYouWorkWith` : 'numberOfStoresYouWorkWith'}
                        name="numberOfStoresYouWorkWith"
                        className={css.numberOfStockists}
                        validate={validators.required('*')}
                      >
                        <option value="" disabled={true}>{pleaseSelectText}</option>
                        {numberOfStores.map(c => {
                          return (
                            <option key={`numberOfStoresYouWorkWith${c.name}`} value={c.name}>
                              {c.name}
                            </option>
                          );
                        })}
                      </FieldSelect>
                    </div>
                  </div>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.leadTime` : 'leadTime'}>
                      <FormattedMessage id="UserFields.leadTime" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('leadTime') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldSelect
                        id={formId ? `${formId}.leadTime` : 'leadTime'}
                        name="leadTime"
                        className={css.avgLeadTime}
                        validate={validators.required('*')}
                      >
                        <option value="" disabled={true}>{pleaseSelectText}</option>
                        {leadTimes.map(c => {
                          return (
                            <option key={`leadTimeSelect${c.name}`} value={c.name}>
                              {c.name}
                            </option>
                          );
                        })}
                      </FieldSelect>
                    </div>
                  </div>
                </div>
                <div className={css.formRow}>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.website` : 'website'}>
                      <FormattedMessage id="UserFields.website" />
                      <span className={css.requiredMarker}>*</span>
                      {hasError('website') && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <div className={css.placeholderContainer}>
                        <div className={css.httpPlaceHolder}>https://</div>
                        <FieldTextInput
                          type="text"
                          id={formId ? `${formId}.website` : 'website'}
                          name="website" className={css.websiteInput}
                          validate={validators.composeValidators(validators.required('*'), validators.validBusinessURL('*'))}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={css.formField}>
                    <label htmlFor={formId ? `${formId}.howDidYouHearAboutVegshelf` : 'howDidYouHearAboutVegshelf'}>
                      <FormattedMessage id="UserFields.howDidYouHearAboutUs" />
                      <span className={css.requiredMarker}>*</span>
                      {(hasError('howDidYouHearAboutVegshelf') || (this.state.aboutTypeEnable && hasError('howDidYouHearAboutVegshelfCustom'))) && (<span className={css.errorMessage}><FormattedMessage id="RequiredField.warningText" /></span>)}
                    </label>
                    <div className={css.fieldInputContainer}>
                      <FieldSelect
                        id={formId ? `${formId}.howDidYouHearAboutVegshelf` : 'howDidYouHearAboutVegshelf'}
                        name="howDidYouHearAboutVegshelf"
                        className={css.hearAboutVegshelf}
                        viewError={(hasError('howDidYouHearAboutVegshelf') || (this.state.aboutTypeEnable && hasError('howDidYouHearAboutVegshelfCustom')))}
                        validate={validators.required('*')} 
                        onChange={this.onChangeAbout}
                      >
                        <option value="" disabled={true}>{pleaseSelectText}</option>
                        {aboutVegshelfCategories.map(c => {
                          return (
                            <option key={`howDidYouHearAboutVegshelfSelect${c.name}`} value={c.name}>
                              {c.name}
                            </option>
                          );
                        })}
                      </FieldSelect>
                      {this.state.aboutTypeEnable ? (
                        <FieldTextInput
                          type="text"
                          id={formId ? `${formId}.howDidYouHearAboutVegshelfCustom` : 'howDidYouHearAboutVegshelfCustom'}
                          name="howDidYouHearAboutVegshelfCustom"
                          validate={validators.required('*')}
                        />) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div className={css.agreeRow}>
                <FieldCheckbox id={formId ? `${formId}.iAgreeToReceive` : 'iAgreeToReceive'}
                  validate={validators.requiredFieldArrayCheckbox('*')} hasError={hasError('iAgreeToReceive')}
                  name="iAgreeToReceive" value="iAgreeToReceive" />
                <label htmlFor={formId ? `${formId}.iAgreeToReceive` : 'iAgreeToReceive'}>
                  <span className={css.requiredMarker}>*</span>
                  <FormattedMessage id="SupplierRegistrationForm.labelIAgreeToReceiveCommunicationFromVegshelf" />
                  <span>
                    <a className={css.agreeRowLinks} href={"/" + locale + "/company/supplier-terms"} /*href="https://www.vegshelf.com/company/supplier-terms"*/ >
                      <FormattedMessage id="SupplierRegistrationForm.linkSupplierTerms" />
                    </a>
                  </span>
                  <FormattedMessage id="BuyerRegistrationForm.And" />
                  <span>
                    <a className={css.agreeRowLinks} href={"/" + locale + "/company/privacy-policy"} /*href="https://www.vegshelf.com/company/privacy-policy"*/ >
                      <FormattedMessage id="BuyerRegistrationForm.linkPrivacyPolicy" />
                    </a>
                  </span>
                  .  
                </label>
              </div>
              <div className={css.bottomWrapper}>
                <PrimaryButton type="submit" className={css.submitButton} inProgress={submitInProgress} disabled={submitInProgress}>
                  <FormattedMessage id="SupplierRegistrationForm.buttonApplyNow" values={{ idp: idp }} />
                </PrimaryButton>
              </div>
            </Form>
          );
        }}
      />
    );
  }
};

SupplierRegistrationFormComponent.defaultProps = { inProgress: false };

const { bool, func } = PropTypes;

SupplierRegistrationFormComponent.propTypes = {
  inProgress: bool,

  // from injectIntl
  intl: intlShape.isRequired,
};

const SupplierRegistrationForm = compose(injectIntl)(SupplierRegistrationFormComponent);
SupplierRegistrationForm.displayName = 'SupplierRegistrationForm';

export default SupplierRegistrationForm;
